/**
 *   RSA_PUBLIC_KEY:a1
  SIGNING_SALT:a2
  ENCRYPTION_SALT:a3
  HEADER_AUTH:a4
  HEADER_TIMESTAMP:a5
  HEADER_NONCE:a6
  HEADER_SIGNATURE:a7
  TIME_WINDOW:a8
  HEADER_ENCRYPT:a9
  HEADER_PLATFORM:a10
 */

// 写死的服务端 RSA 公钥（PEM 格式，从后端获取）
const a1 = `-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDIECCpVmUSYEbGYLQ/JL0X3HwjDj5QsxR6rJc2dEQWihEL80Xngkoq9E3KzCZVYFC6S64nBuszuPNAT47XFkooyDAYL8oS9aTrjYqPaHAvcPKB7W9ptjlLT9be18SEtI8NwHPjAIA2a9jUAIbsZArF198cxZMyxCYKsqHtEJl55wIDAQAB
-----END PUBLIC KEY-----`;

// 固定盐值（必须与后端一致）
const a2 = "zst_sign_key";
const a3 = "zst_encrypt_key";

// 请求头字段
const a4 = "Authorization";
const a5 = "X-Timestamp";
const a6 = "X-Nonce";
const a7 = "X-Signature";
const a9  = "X-Encrypt-Type"
const a10 = "X-Platform"

// 时间窗口（毫秒）
const a8 = 5 * 60 * 1000; // 5分钟

module.exports = {
  a1,
  a2,
  a3,
  a4,
  a5,
  a6,
  a7,
  a8,
  a9,
  a10
};